export const MEMBERSHIP_HEADLINE = 'Calculus Circus is the missing layer in the AP Curriculum';

export const MEMBERSHIP_BENEFITS = [
  'Over 50 skills available with instant feedback',
  'Explanations and reminders of key ideas throughout',
  'Clickable features for graphing practice',
  'Full set of review cards for year-end reminders',
  'Detailed progress tracking that can be shared with your teacher',
  'Teachers can create classes, manage rosters, and view skill activity',
  'One flat, annual fee with no automatic renewal and no automatic charges',
  'No stored credit card information. FERPA protected data privacy',
];
